import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { TvdDistributorComponent } from './components/tvd-distributor/tvd-distributor.component';
import { TvdMetricGroupComponent } from './components/tvd-metric-group/tvd-metric-group.component';
import { TvdOverallComponent } from './components/tvd-overall/tvd-overall.component';
import { IconPlusComponent } from './components/icon-plus/icon-plus.component';
import { IconDeleteComponent } from './components/icon-delete/icon-delete.component';
import { CustomTileItemComponent } from './components/custom-tile-item/custom-tile-item.component';
import { MetricConfirmationBoxComponent } from './components/metric-confirmation-box/metric-confirmation-box.component';
import { CustomTileEditPanelComponent } from './components/custom-tile-edit-panel/custom-tile-edit-panel.component';
import { CustomTileEntryPanelComponent } from './components/custom-tile-entry-panel/custom-tile-entry-panel.component';
import { EbrCoreModule } from 'src/app/core/components/ebr-core.module';
import { EroiMetricComponent } from './components/eroi-metric/eroi-metric.component';
import { TvdDetailsPageComponent } from './components/tvd-details-page/tvd-details-page.component';
import { TotalValueDeliveryComponent } from './total-value-delivery.component';
import { SaveButtonComponent } from './components/save-button/save-button.component';
import { IconAddedComponent } from './components/icon-added/icon-added.component';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { SharedModule } from 'src/app/shared/shared.module';
import { TvdSidenavbarComponent } from './components/tvd-sidenavbar/tvd-sidenavbar.component';
import { ReactiveFormsModule } from '@angular/forms';
import { TvdDialogComponent } from './components/tvd-dialog/tvd-dialog.component';
import { TwoDigitDecimalDirective } from './directives/two-digit-decimal.directive';
import { TvdMetricSummaryComponent } from './components/tvd-metric-summary/tvd-metric-summary.component';
import { TvdValuePillarSummaryComponent } from './components/tvd-value-pillar-summary/tvd-value-pillar-summary.component';
import { CompositeEroiMetricComponent } from './components/composite-eroi-metric/composite-eroi-metric.component';
import { TvdPresentationPreviewComponent } from './components/tvd-presentation-preview/tvd-presentation-preview.component';
import { TvdKpiGridComponent } from './components/tvd-kpi-grid/tvd-kpi-grid.component';
import { TvdProgramTableComponent } from './components/tvd-program-table/tvd-program-table.component';
import { TvdProgramDetailsTableComponent } from './components/tvd-program-details-table/tvd-program-details-table.component';
import { TvdProgramDetailsPageComponent } from './components/tvd-program-details-page/tvd-program-details-page.component';
import { EroiPipe } from './pipes/eroi.pipe';


@NgModule({
  declarations: [
    TvdDistributorComponent,
    EroiMetricComponent,
    IconPlusComponent,
    IconDeleteComponent,
    TvdOverallComponent,
    MetricConfirmationBoxComponent,
    CustomTileEntryPanelComponent,
    CustomTileItemComponent,
    CustomTileEditPanelComponent,
    TotalValueDeliveryComponent,
    TvdDetailsPageComponent,
    TvdMetricGroupComponent,
    IconAddedComponent,
    SaveButtonComponent,
    TvdSidenavbarComponent,
    TvdDialogComponent,
    TwoDigitDecimalDirective,
    TvdMetricSummaryComponent,
    TvdValuePillarSummaryComponent,
    CompositeEroiMetricComponent,
    TvdPresentationPreviewComponent,
    TvdKpiGridComponent,
    TvdProgramTableComponent,
    TvdProgramDetailsTableComponent,
    TvdProgramDetailsPageComponent,
    EroiPipe,
  ],
  exports: [
      TvdDistributorComponent,
      EroiPipe,
  ],
  imports: [
    CommonModule,
    FormsModule,
    AppRoutingModule,
    EbrCoreModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    SharedModule,
    ReactiveFormsModule,
  ],
})
export class TotalValueDeliveryModule {}
